export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Polski'
  },
  'title': 'QUICKDRAWS SIMOND ALPINISM / VERTIKA WYCOFANIE PRODUKTU',
  'homepage': {
    'notice': 'Wycofanie produktu z rynku. Ważne informacje dotyczące bezpieczeństwa i sprzętu.',
    'purchaseWindow': 'W okresie od 1 stycznia 2022 r. do 23 lipca 2026 r. zakupili Państwo ekspres wspinaczkowy ALPINISM i/lub VERTIKA.',
    'skus': 'Ekspres wspinaczkowy Alpinism 11 cm (4051175 / 8589547)\nEkspres wspinaczkowy Alpinism 17 cm (4051176 / 8589548)\nZestaw 5 ekspresów Alpinism (4171656 / 8608405)\nEkspres wspinaczkowy Vertika 11 cm (5499689 / 8935765)\nEkspres wspinaczkowy Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Projektowanie środków ochrony indywidualnej wiąże się z ogromną odpowiedzialnością wobec osób korzystających z naszych produktów. Dlatego informujemy Państwa o akcji wycofania z rynku ekspresów wspinaczkowych wyposażonych w karabinek Rocky Fil.',
    'defect': 'Wykryliśmy wadę montażową w nitowaniu drucianego zamka w niektórych karabinkach. Może ona spowodować pęknięcie drucianego zamka i stwarzać ryzyko pęknięcia karabinka w razie upadku.',
    'stopUsing': 'W trosce o bezpieczeństwo prosimy o natychmiastowe zaprzestanie używania produktu i postępowanie zgodnie z poniższą procedurą.'
  },
  'procedure': {
    'stopUsing': 'W związku z tym prosimy o natychmiastowe zaprzestanie używania tego sprzętu oraz sprawdzenie zgodnie z poniższą instrukcją, czy Państwa produkt posiada opisaną wadę.',
    'title': 'Jak sprawdzić swój produkt:',
    'intro': 'Należy sprawdzić, czy obie strony drucianego zamka są nadal solidnie przymocowane do karabinka:',
    'step1': 'Należy chwycić karabinek z jednej strony i wsunąć kciuk między oba druty zamka, możliwie najbliżej nitu. Następnie mocno docisnąć kciuk w dół w kierunku korpusu karabinka.',
    'step2': 'Odwrócić karabinek i powtórzyć tę samą czynność po drugiej stronie zamka.'
  },
  'outcome': {
    'nok': {
      'body': 'Po sprawdzeniu okazało się, że drut się poluzował: Prosimy o natychmiastowe zaprzestanie użytkowania produktu i zwrócenie go do najbliższego sklepu DECATHLON. Nasz zespół zajmie się wadliwym produktem i niezwłocznie dokona pełnego zwrotu środków za produkt wycofany z rynku.',
      'support': 'W razie trudności nasze Centrum Obsługi Klienta pozostaje do Państwa dyspozycji, aby zaproponować indywidualnie dopasowane rozwiązanie i przeprowadzić Państwa przez cały proces pod numerem: 800808007, czynne od poniedziałku do piątku w godzinach od 09:00 do 19:00, \nw soboty i niedziele handlowe od 09:00 do 17:00 oraz mailowo: kontakt@decathlon.pl.'
    },
    'ok': {
      'body': 'Po sprawdzeniu okazało się, że drut nie wysuwa się z obudowy: Ta wada nie dotyczy Państwa produktu, można nadal z niego korzystać bez żadnych obaw.'
    }
  },
  'buttons': {
    'ok': 'Mój produkt jest OK',
    'nok': 'Mój produkt jest NOK'
  }
} as const
